// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient svg module decls must travel with these files: consumers (e.g. functions) compile ui-kit sources transitively without our tsconfig include
/// <reference path="./svg.d.ts" />
// packages/ui-kit/src/brand/AppIcon.tsx
// C3F v18 — reference: design/system/components/brand/AppIcon.{jsx,prompt.md}
// The AE symbol on Night, V8-notch squircle. Use it wherever the brand must
// appear below 34px: rail top, favicons, avatars. It never changes per theme.
import { type ImgHTMLAttributes } from "react";
import appIconUrl from "./assets/praesto-appicon.svg";

interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {
  size?: number;
  /** 22.5% is the V8 notch of the icon master — override only for tight fits
   *  inside other rounded shapes (e.g. the AiAnswer spectrum ring). */
  radius?: string;
}

export function AppIcon({ size = 44, radius = "22.5%", style, ...rest }: Props) {
  return (
    <img
      src={appIconUrl}
      alt="Praesto"
      width={size}
      height={size}
      style={{ width: size, height: size, borderRadius: radius, display: "block", ...style }}
      {...rest}
    />
  );
}
